module.exports = require("os");


//////////////////
// WEBPACK FOOTER
// external "os"
// module id = 25
// module chunks = 0 1 2 3